import styled from "styled-components";

export const ModalStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  z-index: 1000;
  background-color: rgb(0 0 0 / 60%);

  &.modal-only-body {
    .modal-container {
      justify-content: initial;
    }
  }

  .modal-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    font-size: 14px;
    color: var(--text-primary);
    background-color: var(--hv-surface-popup);
    border: 1px solid var(--hv-border-default);
    width: 400px;
    min-height: 148px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: var(--hv-radius-xl);
    box-shadow: 0px 16px 24px 0px var(--hv-shadow-4);
    padding: var(--hv-spacing-5) var(--hv-spacing-6);
    gap: var(--hv-spacing-3);

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0;

      .modal-title {
        font-size: var(--hv-fontsize-body-xl);
        color: var(--hv-text-normal-primary);
        font-weight: 700;
        line-height: var(--hv-lineheight-headline-2xs);
        letter-spacing: 0%;
      }

      .modal-close {
        cursor: pointer;
      }
    }

    .modal-body {
      padding: 0;
      padding-bottom: var(--hv-spacing-1);
      font-size: var(--hv-fontsize-body-sm);
      line-height: var(--hv-lineheight-body-sm);
      letter-spacing: 0%;
    }

    .modal-footer {
      width: 100%;
      display: flex;
      justify-content: space-between;
      border: 0;
      padding: 0;

      > div:last-child {
        > button {
          &:not(:first-child) {
            margin-left: 10px;
          }
        }
      }
    }
  }
`;
